import styled from '@emotion/styled';

const WebView = styled.div({
  '@media(max-width:500px)': {
    display: 'none',
  },
});

export default WebView;
